import * as React from "react";
import * as PropTypes from "prop-types";

import { RS } from "../../../../data/strings/global";
import * as SC from "../../../../data/strings/PIStringConst";

import * as Theme from "../../../../app/Theme";

import TSlideDrawer from "../../../common/TSlideDrawer";

import * as gbu from "../../../GB/GBUtil";

import PITargScaleUpRefForm from "../../Forms/Reference/PITargScaleUpRefForm";
import * as pip from "../../NonComponents/PIProps";
import * as pias from "../../NonComponents/PIAppState";
import * as php from "../../NonComponents/PIHelp";
//import THelpButton from "../../../common/THelpButton";

class PITargScaleUpRefSlideDrawer extends React.Component {
  static propTypes = {
    [pias.helpAreaStr]: PropTypes.string,
    [pias.onHelp]: PropTypes.func,

    [pip.progDataPeriodObj]: PropTypes.object,

    [pip.scaleUpTrendsObjList]: PropTypes.arrayOf(PropTypes.object),

    [pip.targSettingPeriodObj]: PropTypes.object,

    [pip.onToggleRefSlideDrawer]: PropTypes.func,
  };

  static defaultProps = {
    [pias.helpAreaStr]: php.targ_ScaleUpRD_HP,
    [pias.onHelp]: () => console.log(pias.onHelp),

    [pip.progDataPeriodObj]: {},

    [pip.scaleUpTrendsObjList]: [],

    [pip.targSettingPeriodObj]: {},

    [pip.onToggleRefSlideDrawer]: () => console.log(pip.onToggleRefSlideDrawer),
  };

  //==================================================================================================================
  //
  //                                        Life Cycle Events
  //
  //==================================================================================================================

  shouldComponentUpdate(nextProps, nextState, nextContext) {
    return gbu.shouldComponentUpdateGB(this.props, nextProps, this.state, nextState);
  }

  //==================================================================================================================
  //
  //                                              Event Handlers
  //
  //==================================================================================================================

  onHelpBtnClick = () => {
    this.props.onHelp();
  };

  //==================================================================================================================
  //
  //                                              Render
  //
  //==================================================================================================================

  render() {
    /* props */

    const props = this.props;
    const progDataSettingPeriodObj = props[pip.progDataPeriodObj];
    const scaleUpTrendsObjList = props[pip.scaleUpTrendsObjList];
    const targSettingPeriodObj = props[pip.targSettingPeriodObj];

    const onToggleRefSlideDrawer = props[pip.onToggleRefSlideDrawer];

    /* state */

    //const state = this.state;

    const targScaleUpRefFormComp = (
      <PITargScaleUpRefForm
        {...{
          [pip.progDataPeriodObj]: progDataSettingPeriodObj,

          [pip.scaleUpTrendsObjList]: scaleUpTrendsObjList,

          [pip.targSettingPeriodObj]: targSettingPeriodObj,
        }}
      />
    );

    const slideDrawer = (
      <TSlideDrawer
        anchor={"right"}
        onClose={onToggleRefSlideDrawer}
        content={targScaleUpRefFormComp}
        headerTitleStyle={{
          color: Theme.PI_PrimaryColor,
        }}
        saveButton={false}
        title={RS(SC.GB_stScaleUp)}
        width={Theme.slideDrawerLv2Width}
        //helpBtn={<THelpButton Theme={Theme} onClick={this.onHelpBtnClick} />}
      />
    );

    return slideDrawer;
  }
}

export default PITargScaleUpRefSlideDrawer;
